import { useEffect, useState } from 'react';
import ConfigurationSection from '../ConfigurationSecton/index';
import YamlActionsContainer from './YamlActionsContainer/index';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { Icon } from 'components/Icons';
import { sendAmplitudeEvents } from 'utils/common';
import { EventNames } from 'utils/events';

import './index.css';

const YamlConfiguarationStep = ({
  changeConcurrencyValue,
  changeRetryValue,
  changeTimeoutValue,
  concurrencyValue,
  currentFramework,
  currentOsSelection,
  getYamlCode,
  handleOsChange,
  retryValue,
  testStarted,
  timeoutValue,
  updateYaml,
}) => {
  const [toggleActive, setToggleActive] = useState(false);

  useEffect(() => {
    testStarted && setToggleActive(false);
  }, [testStarted]);

  function handleToggle(value) {
    setToggleActive(value);
    const message = toggleActive ? 'close dialog box' : 'open dialog box';
    sendAmplitudeEvents(EventNames.HYP_QUICK_RUN_UPDATE_YAML, {
      parameter: 'dialog box',
      message,
    });
  }

  const CodeMirrorDefaultOption = {
    mode: 'text/x-yaml',
    lineWrapping: true,
    indentWithTabs: false,
    lint: {
      highlightLines: true,
    },
    gutters: ['CodeMirror-lint-markers'],
  };

  const ThemeOption = {
    ...CodeMirrorDefaultOption,
    theme: 'mytheme',
    lineNumbers: true,
  };

  return (
    <div className="yaml-configuaration-step-container">
      <div
        className={
          'ltw-border-l ltw-border-dashed ltw-border-opacity-40 ltw-border-primary ltw-border-gray-7 ltw-mb-35px completed-step-container'
        }
      >
        <Icon name="completed-step" className="completed-step-icon" />
      </div>
      <ConfigurationSection classname="configration-section-border">
        <YamlActionsContainer
          handleOsChange={handleOsChange}
          concurrencyValue={concurrencyValue}
          changeConcurrencyValue={changeConcurrencyValue}
          retryValue={retryValue}
          changeRetryValue={changeRetryValue}
          timeoutValue={timeoutValue}
          changeTimeoutValue={changeTimeoutValue}
          currentOsSelection={currentOsSelection}
          toggleActive={toggleActive}
          setToggleActive={handleToggle}
        />
        <div className="yaml-wrapper">
          <div
            as="button"
            role="button"
            className="controls-view-icon"
            onClick={() => handleToggle((currentState) => !currentState)}
            onKeyDown={() => {}}
            tabIndex={0}
          >
            {toggleActive ? (
              <Icon name="chevron/up" />
            ) : (
              <Icon name="chevron/down" />
            )}
          </div>
          {!!toggleActive && (
            <div className="sampletest-yaml-container">
              <div className="yml-container ltw-relative">
                <CodeMirror
                  value={getYamlCode(currentFramework.yamlCode)}
                  options={ThemeOption}
                  onBeforeChange={(editor, data, value) => {
                    updateYaml(value);
                  }}
                  onChange={(editor, data, value) => {
                    updateYaml(value);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </ConfigurationSection>
    </div>
  );
};

export default YamlConfiguarationStep;
